module.exports = __webpack_public_path__ + "static/media/ic-search.d27841ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-search.svg
// module id = 657
// module chunks = 0